import React from 'react';
import { Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

/**
 * ViewVersionButton - כפתור צפייה בגירסה האחרונה
 * 
 * @param {function} onView - callback לצפייה בגירסה
 * @param {boolean} disabled - האם הכפתור מושבת
 * @param {boolean} fullWidth - האם הכפתור ברוחב מלא
 */
const ViewVersionButton = ({ onView, disabled = false, fullWidth = true }) => {
    return (
        <Button
            fullWidth={fullWidth}
            variant="outlined"
            startIcon={<VisibilityIcon />}
            onClick={onView}
            disabled={disabled}
            sx={{
                borderColor: '#1e3a5f',
                color: '#1e3a5f',
                fontWeight: 500,
                px: 2,
                py: 0.5,
                fontSize: '0.875rem',
                borderRadius: '12px',
                textTransform: 'none',
                minHeight: '36px',
                '&:hover': {
                    borderColor: '#2d5a8f',
                    bgcolor: 'rgba(30,58,95,0.04)'
                },
                '&.Mui-disabled': {
                    borderColor: 'rgba(30,58,95,0.3)',
                    color: 'rgba(30,58,95,0.3)'
                },
                gap: 1
            }}
        >
            צפה בתצוגה מקדימה
        </Button>
    );
};

export default ViewVersionButton;
